import { reactive } from "vue";

/**
 * Service for managing booking budget error handling
 * Similar to conflictService but for budget/points errors
 */
export class BudgetService {
	constructor() {
		this.state = reactive({
			hasBudgetError: false,
			errorDetails: null,
			originalData: {},
			originalMode: "",
		});
	}

	setBudgetError(budgetError) {
		this.state.hasBudgetError = true;
		this.state.errorDetails = {
			status: budgetError.status,
			error: budgetError.error,
			budget: budgetError.budget,
			budgetDetails: budgetError.budgetDetails,
		};
		this.state.originalData = budgetError.originalData || {};
		this.state.originalMode = budgetError.originalMode || "";
	}

	clearBudgetError() {
		this.state.hasBudgetError = false;
		this.state.errorDetails = null;
		this.state.originalData = {};
		this.state.originalMode = "";
	}

	getBudgetErrorData() {
		return {
			hasBudgetError: this.state.hasBudgetError,
			errorDetails: this.state.errorDetails ? { ...this.state.errorDetails } : null,
		};
	}

	getOriginalData() {
		return { ...this.state.originalData };
	}
	
	getOriginalMode() {
		return this.state.originalMode;
	}

	hasActiveBudgetError() {
		return this.state.hasBudgetError;
	}
}

/**
 * Composable for using budget service in components
 */
export function useBudgetService() {
	const budgetService = new BudgetService();

	return {
		budgetState: budgetService.state,
		setBudgetError: (error) => budgetService.setBudgetError(error),
		clearBudgetError: () => budgetService.clearBudgetError(),
		getBudgetErrorData: () => budgetService.getBudgetErrorData(),
		getOriginalData: () => budgetService.getOriginalData(),
		getOriginalMode: () => budgetService.getOriginalMode(),
		hasActiveBudgetError: () => budgetService.hasActiveBudgetError(),
	};
}